import type { PlanResponseBillingCycle } from './planResponseBillingCycle';

export interface PlanResponse {
  /** Text to display on the action button */
  actionText: string;
  /** Price amount in the smallest currency unit (e.g., won) */
  amount: number;
  /** Billing frequency */
  billingCycle: PlanResponseBillingCycle;
  /**
   * Country code that resolved the displayed price
   * @nullable
   */
  countryCode?: string | null;
  /**
   * Currency code used by the resolved catalog price
   * @nullable
   */
  currencyCode?: string | null;
  /**
   * Display price resolved from the regional catalog
   * @nullable
   */
  displayPrice?: string | null;
  /** List of features included in this plan */
  features: string[];
  /** Unique identifier for the plan */
  id: string;
  /** Whether this plan supports recurring billing */
  isBillingPlan: boolean;
  /** Display name of the plan */
  name: string;
  /**
   * Original price amount before regional or promotional adjustments
   * @nullable
   */
  originalAmount?: number | null;
  /** Formatted price string for display */
  price: string;
  /**
   * Source of the resolved price
   * @nullable
   */
  priceSource?: string | null;
  /** Product code this plan belongs to */
  productCode: string;
  /** Specific plan code for backend plan lookup */
  productPlanCode: string;
  /** Whether this plan is recommended */
  recommended?: boolean;
}
